export default __webpack_public_path__ + "static/media/ic_glp_arbitrum.d04b88c9.svg";